import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Spinner from '../../../services/spinner'



export default function AccountDetailsComponent(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);


  return (
    <React.Fragment>

   
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small right animate__animated animate__slideInRight animate__faster" ref={handleClickAway}>


                {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div><h2>Account Details</h2></div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                     <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={6} className="strong">Account Number</Table.Cell>
                          <Table.Cell width={10}>{props.data.account_number}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Account Name</Table.Cell>
                          <Table.Cell>{props.data.account_name}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Email</Table.Cell>
                          <Table.Cell>{props.data.email}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Password</Table.Cell>
                          <Table.Cell>{props.data.password}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Account Type</Table.Cell>
                          <Table.Cell>{parse(props.data.account_type)}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>

                    
                    {props.data.address.map(function(row, key){
                      return<React.Fragment key={key}>
                        <Table definition color='red'>
                            <Table.Body>

                              <Table.Row>
                                <Table.Cell colSpan='2' style={{'text-transform':'uppercase','font-weight':'bold'}}>Address {row.id}</Table.Cell>
                              </Table.Row>

                              {row.pharmacy!=''&&<Table.Row>
                                <Table.Cell width={6}>Pharmacy</Table.Cell>
                                <Table.Cell width={10}>{row.pharmacy}</Table.Cell>
                              </Table.Row>}

                              {row.reference!=''&&<Table.Row>
                                <Table.Cell width={6}>Reference</Table.Cell>
                                <Table.Cell width={10}>{row.reference}</Table.Cell>
                              </Table.Row>}

                              <Table.Row>
                                <Table.Cell width={6}>Line 1</Table.Cell>
                                <Table.Cell width={10}>{row.line_1}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Line 2</Table.Cell>
                                <Table.Cell>{row.line_2}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Line 3</Table.Cell>
                                <Table.Cell>{row.line_3}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Phone</Table.Cell>
                                <Table.Cell>{row.phone}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>City</Table.Cell>
                                <Table.Cell>{row.city}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>County</Table.Cell>
                                <Table.Cell>{row.county}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Postcode</Table.Cell>
                                <Table.Cell>{row.postcode}</Table.Cell>
                              </Table.Row>

                              <Table.Row>
                                <Table.Cell>Country</Table.Cell>
                                <Table.Cell>{row.country}</Table.Cell>
                              </Table.Row>

                          </Table.Body>
                        </Table>
                      </React.Fragment>
                    })}

                      
                    <Table definition>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell width={6} className="strong">Activities</Table.Cell>
                          <Table.Cell width={10}>{parse(props.data.activities)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Product Pricing</Table.Cell>
                          <Table.Cell>{parse(props.data.status_pricing)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Status</Table.Cell>
                          <Table.Cell>{parse(props.data.status)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell className="strong">Comments</Table.Cell>
                          <Table.Cell>{props.data.comments}</Table.Cell>
                        </Table.Row>

                        <Table.Row>
                          <Table.Cell className="strong">Date Modified</Table.Cell>
                          <Table.Cell className="now-wrapp">
                            <div className="descriptionTable">
                              <div>
                                  <h3>{props.data.date_added}</h3>
                                  <p>{props.data.time_added}</p>
                              </div>
                            </div>
                          </Table.Cell>
                        </Table.Row>

                        <Table.Row>
                          <Table.Cell className="strong">Modified By</Table.Cell>
                          <Table.Cell>
                          <div className="profileTable">
                              <div><img src={props.data.account.image}/></div>
                              <div>
                                  <h3>{props.data.account.fullname}</h3>
                                  <p>{props.data.account.role_account}</p>
                              </div>
                            </div>
                          </Table.Cell>
                        </Table.Row>

                      </Table.Body>
                    </Table>

                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer right">
                    <Button className="RedButton uppercase strong" size='small' content='Close Window' icon='sign-out' labelPosition='right' 
                    onClick={()=>CallbackModal({close:true})}/>
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          
    </React.Fragment>
  )
}
